module.exports = __webpack_public_path__ + "img/add_image_black.573a0342.svg";